import { render, staticRenderFns } from "./ConnectionsHistogram.vue?vue&type=template&id=30457b7f"
import script from "./ConnectionsHistogram.vue?vue&type=script&lang=js"
export * from "./ConnectionsHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports